const BLIK_RECURRING_NOT_SUPPORTED = 'recurring_not_supported_by_bank';

export const getIsBlikRejected = (error) => {
	if (!error) {
		return false;
	}

	const declineCode =
		error.decline_code ||
		error.payment_intent?.last_payment_error?.decline_code ||
		error.setup_intent?.last_setup_error?.decline_code;

	return declineCode === BLIK_RECURRING_NOT_SUPPORTED;
};
